module.exports.default = {
    "ORDER": "הזמנה",
    "SCHEDULE.YOU_ARE_ALL_SET": "זמן המשלוח הוגדר בהצלחה",
    "SCHEDULE.YOUR_DELIVERY_IS_SCHEDULED_FOR": "הזמנתך נקבעה ל",
    "SCHEDULE.CUSTOMER_#_MESSAGE": "שלום #, אנא בחר תאריך למשלוח",
    "SCHEDULE.SCHEDULE_NOW": "בחר חלון",
    "SCHEDULE.DELIVERY_STATUS_UPDATES": "מרכז שליחת התראות",
    "SCHEDULE.EMAIL_UPDATES": "מעוניין לקבל הזמנות באימייל",
    "SCHEDULE.SMS_UPDATES": "מעוניין לקבל התראות ב sms",
    "SCHEDULE.DISABLE_UPDATES": "לא מעוניין לקבל התראות",
    "SCHEDULE.STATUS_UPDATE_IN_THE_FOLLOWING": "אני מעוניין לקבל התראות בערוצים הבאים:",
    "OOPS": "אופס!",
    "SOMETHING_WENT_WRONG": "אירעה שגיאה",
    "REFRESH": "רענון",
    "PAGE_NOT_FOUND": "הדף לא נמצא",
    "COULD_NOT_FIND_PAGE": "הדף שחיפשת אינו נמצא",
    "TRACKING.MESSAGE_DRIVER_FAILED": "לא ניתן לשלוח הודעה ריקה",
    "TRACKING.MESSAGE_DRIVER_PLACEHOLDER": "ניתן לשלוח הודעה לנהג",
    "TRACKING.SEND": "שלח",
    "TRACKING.ARRIVING_AT": "הגעה",
    "TRACKING.ETA": "הגעה",
    "TRACKING.MIN": "דקות",
    "TRACKING.MAP": "תנועה",
    "TRACKING.SATELLITE": "לווין",
    "TRACKING.TERRAIN": "שטח",
    "TRACKING.DRIVER_ARRIVED_MESSAGE": "!הגעתי",
    "TRACKING.DRIVER_ARRIVED_AT_MESSAGE": "הגיע אל",
    "COMPLETED": "אין לך כרגע שליחויות פעילות",
    "RATING.SKIP": "לא כעת",
    "RATING.WHAT_WENT_WELL": "מה הלך טוב?",
    "RATING.WHAT_WENT_WRONG": "מה השתבש?",
    "RATING.THANK_YOU": "תודה !",
    "RATING.FOR_USING_OUR_SERVICE": "שבחרת להשתמש בשירות שלנו!",
    "RATING.HOW_WAS_YOUR_DELIVERY": "איך הייתה חווית השירות שלך?",
    "RATING.WHAT_WAS_YOUR_EXPERIENCE": "עזרו לנו להשתפר ודרגו את השירות שקבלתם מהשליח",
    "SCHEDULE.RATE_US": "דרגו אותנו",
    "TERM_OF_USE": "תנאי שימוש",
    "PRIVACY_POLICY": "מדיניות פרטיות",
    "SHARING_MY_LOCATION": "שידור מיקום נוכחי",
    "SHARING_LOADING": "טוען",
    "REQUIRED_FIELD_MESSAGE": "שדות חובה",
    "CONTACT_NAME": "איש קשר",
    "PHONE_NUMBER": "נייד",
    "EMAIL_ADDRESS": "אימייל",
    "SEND": "שלח",
    "FORWARD.THIS_ORDER": "העבר קבלת הזמנה",
    "FORWARD.TO_CONTACT": "העבר לאיש קשר",
    "FORWARD.ARE_YOU_SURE_MESSAGE": "האם ברצונך להעביר את ההזמנה לאיש קשר חדש?",
    "FORWARDED.HAS_DELIVERY_FORWARDED_DELIVERY": "העביר/ה את הזמנתו אליך",
    "FORWARDED.ARE_YOU_SURE_MESSAGE": "האם ברצונך לדחות את ההזמנה?",
    "ACCEPT": "אשר",
    "REJECT": "דחה",
    "PICKUP.SET_PICKUP_TIME": "אני בדרך",
    "PICKUP.IVE_ARRIVED": "הגעתי",
    "PICKUP.PICKUP_ETA_SET_FAILED": "אופס, משהו השתבש",
    "PICKUP.ETA_SET_FAILED_DESCRIPTION": "אנא נסה שנית",
    "PICKUP.MIN": "דקות",
    "PICKUP.SHOW_THIS_NUMBER": "הראה את מספרך בדלפק על מנת לקבל את הזמנתך",
    "PICKUP.IM_OUTSIDE": "אני כאן",
    "PICKUP.LET_THEM_KNOW_YOUR_OUTSIDE?": "האם הגעת ליעד?",
    "PICKUP.I_WILL_ARRIVE_AT": "אגיע ב:",
    "PICKUP.PICKUP_ETA_SUCCESSFULLY_SET": "זמן הגעה הוגדר בהצלחה",
    "PICKUP.IN": "ב",
    "PICKUP.TO": "ל",
    "PICKUP.COLLECT": "איסוף",
    "PICKUP.SELECT_METHOD_OF_TRANSPORT": "בחר אמצעי תחבורה",
    "PICKUP.CONFIRM_METHOD_OF_TRANSPORT": "אשר אמצעי תחבורה",
    "PICKUP.CANCEL": "ביטול",
    "PICKUP.CONFIRM_TIME": "אשר זמן הגעה",
    "TRACKING.DRIVER_ROUTE_ONE_STOP_MESSAGE": "הנהג נמצא כתחנה אחת מיעדך",
    "TRACKING.DRIVER_ROUTE_STOPS_MESSAGE_PART2": "תחנות מיעדך",
    "TRACKING.DRIVER_ROUTE_STOPS_MESSAGE_PART1": "הנהג נמצא כ",
    "PICKUP.OK": "אוקיי",
    "PICKUP.NEXT": "הבא",
    "PICKUP.SKIP": "דלג",
    "CAR_ARRIVED.TITLE": "השלב האחרון! תן לנו לדעת איך למצוא אותך:",
    "CAR_ARRIVED.PARKING_SPOT": "מספר אזור חניה / מקום חניה",
    "CAR_ARRIVED.LICENSE_PLATE": "מספר רישוי",
    "CAR_ARRIVED.VEHICLE_MODEL": "דגם ויצרן הרכב",
    "CAR_ARRIVED.VEHICLE_COLOR": "צבע הרכב",
    "CAR_ARRIVED.REMEMBER": "זכור את פרטי הרכב שלי",
    "CAR_ARRIVED.PARKING_SPOT_EXAMPLE": "(לדוגמה: C - 49)",
    "CAR_ARRIVED.LICENSE_PLATE_EXAMPLE": "(לדוגמה: 195-QUD)",
    "CAR_ARRIVED.VEHICLE_MODEL_EXAMPLE": "(לדוגמה: פורד ברונקו)",
    "CAR_ARRIVED.VEHICLE_COLOR_EXAMPLE": "(לדוגמה: כחול)",
    "REDIRECT_PICKUP.TO": "אל",
    "REDIRECT_PICKUP.CONFIRM_TITLE": "לשנות את מיקום האיסוף?",
    "REDIRECT_PICKUP.SUCCESS_TITLE": "מיקום האיסוף שונה בהצלחה",
    "REDIRECT_PICKUP.FAILED_TITLE": "לא ניתן לשנות את מיקום האיסוף",
    "REDIRECT_PICKUP.FAILED_DESCRIPTION": "משהו השתבש",
    "REDIRECT_PICKUP.OK": "אוקיי",
    "REDIRECT_PICKUP.KM": "ק״מ",
    "REDIRECT_PICKUP.SELECT_PICKUP_LOCATION": "בחר את מיקום האיסוף",
    "REDIRECT_PICKUP.SET_AS_PICKUP_LOCATION": "קבע כמיקום איסוף",
    "REDIRECT_PICKUP.PICKUP_OPTIONS": "אפשרויות איסוף",
    "SOON": "בקרוב",
    "TRACKING.WANT_TO_CALL_YOUR_DRIVER": "רוצה להתקשר לשליח שלך?",
    "GLOBAL.CALL": "התקשר",
    "GLOBAL.CANCEL": "ביטול",
    "﻿PICKUP.SET_PICKUP_TIME": "אני בדרך",
    "RATING.PROOF_OF_DELIVERY_MESSAGE": "ההזמנה שלך מחכה לך ממש מחוץ לדלת!",
    "SCHEDULED.THANKS_FOR_USING": "תודה שהשתמשת ב- {{merchant_name}}",
    "SCHEDULED.SHIPMENT_IN_TRANSIT": "המשלוח שלך {{external_id}} נמצא בדרך",
    "SCHEDULED.YOUR_DELIVERY_IS_SCHEDULED_FOR": "ההזמנה שלך מתוכננת ל",
    "Submit": "שלח",
    "RATING.SELECT_STARS_BEFORE_SUBMIT": "כדי לדרג, בחר תחילה את הכוכבים",
    "PICKUP.SHOW_ID": "הצג מספר",
    "TRACKING.ESTIMATED_TIME_ARRIVAL": "זמן הגעה משוער",
    "OPEN_MENU": "תפריט פתיחה",
    "CLOSE_MENU": "סגור תפריט",
    "MAP_AUTO_CENTER": "מפת מרכז הרכב",
    "MAP_SETTINGS": "הגדרות מפה",
    "ZOOM_OUT": "הקטן תצוגה",
    "ZOOM_IN": "הגדל תצוגה",
    "TRACKING.CALL_DRIVER": "התקשר לנהג",
    "TRACKING.MESSAGE_DRIVER": "שלח הודעה לנהג",
    "PICKUP.SELECT_TIME_TO_CONFIRM": "אשר את זמן הגעת האיסוף",
    "PICKUP.SET_OR_ARRIVE_DESCRIPTION": "אנחנו לא רוצים שתחכה.\nתן לנו לדעת מתי אתה בדרך או מגיע:",
    "SCHEDULE.TIME_ZONE_TEXT": "אזור זמן",
    "TRACKING.THANKS_MESSAGE_SUBTITLE": "אנחנו עובדים על זה!",
    "TRACKING.THANKS_MESSAGE_TEXT": "אנו אוספים את הפריטים שלך וחבר צוות יגיע לרכבך בקרוב",
    "TRACKING.THANKS_MESSAGE_TITLE": "תודה על עדכון",
    "TRACKING.CLICK_COLLECT_MESSAGE_TEXT": "אנא עבור אל נקודת האיסוף בחנות שבה ההזמנה שלך מוכנה לאיסוף",
    "CANCEL_ORDER": "ביטול הזמנה",
    "CANCELLATION_VALIDATION_TITLE": "האם אתה בטוח שברצונך לבטל הזמנה זו?",
    "CANCELLATION_VALIDATION_BACK": "חזור",
    "CANCELLATION_VALIDATION_YES": "כן, בבקשה",
    "CANCEL_SUCCESS": "ביטלנו את ההזמנה שלך",
    "CANCEL_PAST_ALLOWED": "ביטול ההזמנה פג",
    "CANCEL_ERROR": "לא הצלחנו לבטל את ההזמנה שלך",
    "RATING.FREE_TEXT_COMMENT": "ספר לנו עוד",
    "RATING.ORDER_DELIVERED_GREEN": "סיפקנו את ההזמנה שלך באמצעות רכב ידידותי לסביבה",
    "CX_ORDER_STATUS.CONFIRMED": "ההזמנה אושרה. אנחנו על זה.",
    "CX_ORDER_STATUS.RECEIVED": "ההזמנה התקבלה. אנו ניצור קשר בקרוב.",
    "CX_ORDER_STATUS.FINDING_DRIVER": "אנו מוצאים נהג להזמנה שלך.",
    "CX_ORDER_STATUS.DRIVER_FOUND": "מצאנו את הנהג להזמנתך.",
    "CX_ORDER_STATUS.PICKING_UP": "אנו מרימים את ההזמנה שלך כרגע.",
    "CX_ORDER_STATUS.WAY_TO_PICKUP": "אנחנו בדרך לאסוף את ההזמנה שלך.",
    "CX_ORDER_STATUS.ON_PREVIOUS_DELIVERY": "אנו מסיימים משלוח קודם לפני ההזמנה.",
    "CX_ORDER_STATUS.WAY_TO_DROPOFF": "ההזמנה שלך בדרך אליך עכשיו!",
    "CX_ORDER_STATUS.ARRIVED": "ההזמנה שלך הגיעה!",
    "TRACKING.DELIVERY_STATUS_TITLE": "סטטוס משלוח",
    "CONFIGURATION.TAGS.SHOW_DELIVERY_STATUS": "הצג את סטטוס המסירה לצרכנים",
    "CONFIRM": "אשר",
    "FLOW_OPTIONS.TITLE": "איך אתה רוצה לאסוף ההזמנה שלך?",
    "FLOW_OPTIONS.CURBSIDE_BUTTON_LABEL": "מועבר לרכב שלך במקום ייעודי",
    "FLOW_OPTIONS.CURBSIDE_BUTTON_TEXT": "שפת המדרכה",
    "FLOW_OPTIONS.CLICK_AND_COLLECT_LABEL": "איסוף בחנות או במיקום קבוע",
    "FLOW_OPTIONS.CLICK_AND_COLLECT_TEXT": "לחץ ואסוף",
    "RATING_STAR_ALT": "בחר עד 5 כוכבים כדי לשלוח דירוג",
    "RATING_STAR_ALT_ONE": "בחר כדי לשלוח",
    "RATING_STAR_ALT_TWO": "דירוג כוכבים",
    "TRACKING.ARRIVING_IN_ARIA_LABEL": "זמן ההגעה המשוער הוא",
    "TRACKING.MAP_CONTAINER_ARIA_LABEL": "מפה למעקב אחר ההזמנה",
    "SCHEDULE.EXTERNAL_ID_INFO": "מספר הזמנה: {{externalId}}",
    "SCHEDULE.TASK_NOTE_LABEL": "תגובה",
    "SCHEDULE.CANCEL_NOTE_INPUT": "נקה",
    "DELIVERY_WAS_CANCELLED": "משלוח בוטל",
    "QUESTIONNAIRE.SKIP": "דלג",
    "QUESTIONNAIRE.SKIP_VALIDATION_HEADER": "האם אתה בטוח שברצונך לדלג?",
    "QUESTIONNAIRE.SKIP_VALIDATION_MESSAGE": "ישנן שאלות שלא נענו. האם אתה בטוח שברצונך להמשיך מבלי להשלים אותן?",
    "QUESTIONNAIRE.BACK": "חזור",
    "QUESTIONNAIRE.SUBMIT_FAILED": "",
    "QUESTIONNAIRE.SUBMIT_SUCCESS": "",
    "QUESTIONNAIRE.NA_VALUE": "",
    "QUESTIONNAIRE.SUBMIT_SUCCESS_TITLE": "",
    "QUESTIONNAIRE.SUBMIT_SUCCESS_MESSAGE": "",
    "QUESTIONNAIRE.PROGRESS_BAR_TITLE": "",
    "QUESTIONNAIRE.NEXT": "",
    "QUESTIONNAIRE.INVALID_FORMAT": ""
};
	